import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewAttendancePage () {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const attendance = location?.state?.attendance || null

  const columns = [
    { field: 'employee.first_name', header: t('first_name'), body: row => `${row.employee?.first_name || ''} ${row.employee?.last_name || ''}` },
    { field: 'days', header: t('days') },
    { field: 'month', header: t('month') },
    { field: 'year', header: t('year') },
    { field: 'description', header: t('description') }
  ]

  if (!attendance) {
    return (
      <div>
        <PageHeader title={t('Attendance_Details')} backPath={'/manager/attendance'} />
        <p className='mt-4'>{t('No_attendance_selected')}</p>
        
      </div>
    )
  }

  const data = [attendance]

  return (
    <div>
      <PageHeader title={t('Attendance_Details')} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
